// import React, { useState } from "react";
// import Avatar from "../Common/Avatar";
// import pic from "../../assets/images/profile-dummy.png";
// import Button from "../Buttons/Button";
// import Drawer from "../Modal/Drawer";
// import FormFieldSet from "../FormFields/FormFieldSet";

// const SignatureCard = ({
//   style = "Style-1",
//   name = "Anna Jack",
//   title = "Junior Frontend Developer",
//   phone = "9604637578",
//   mobile = "9845290545",
//   web = "yue@yu.in",
//   email = "annajack54@gmail.com",
//   address = "76, Church street, Dallas, USA",
//   image = "",
//   socialIcons = [
//     { icon: "f", className: "bg-info-200 text-info-500" },
//     { icon: "in", className: "text-white bg-info-500" },
//     { icon: "m", className: "bg-info-200 text-info-500" },
//     { icon: "x", className: "bg-info-200 text-info-500" },
//   ],
// }) => {
//   const [editModal, setEditModal] = useState(false);
//   return (
//     <div className="relative border border-neutrals-500  rounded">
//       <div className="bg-primary-200 text-neutrals-700 px-3 py-1 text-sm font-medium w-fit rounded-br-xl absolute -left-1 -top-1">
//         {style}
//       </div>

//       <div className="flex gap-4 p-3 pt-8 flex-1">
//         <div className="flex flex-col flex-shrink-0">
//           {image ? (
//             <img
//               src={image}
//               className="w-20 h-20 rounded object-cover"
//               alt="Profile"
//             />
//           ) : (
//             <Avatar className="w-20 h-20" src={pic} />
//           )}

//           {/* Conditional rendering for social media icons */}
//           {socialIcons.length > 0 && (
//             <div className="flex gap-2 my-4 flex-wrap">
//               {socialIcons.map((social, index) => (
//                 <div
//                   key={index}
//                   className={`text-center px-1 text-sm rounded ${
//                     social.className || "bg-info-200 text-info-500"
//                   }`}
//                 >
//                   {social.icon || social.text}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <div className="flex flex-1 flex-col ">
//           <div className="flex justify-between items-center">
//             <div className="flex-1 ">
//               <p className="font-semibold text-2xl truncate">{name}</p>
//               <p className="text-gray-600 text-xs">{title}</p>
//             </div>
//             <Button
//               type="icon"
//               variant="text"
//               color="black"
//               icon={"edit"}
//               size="xl"
//               onClick={() => setEditModal(true)}
//             />
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-3 mt-3 text-sm flex-1">
//             <p className="truncate">
//               <span className="font-medium">Phone:</span> {phone}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Mobile:</span> {mobile}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Web:</span> {web}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Email:</span> {email}
//             </p>
//             <div className="col-span-1 sm:col-span-2">
//               <p>
//                 <span className="font-medium">Address:</span> {address}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Drawer
//         title={"Edit Signature"}
//         isOpen={editModal}
//         onClose={() => setEditModal(false)}
//         width="w-[50%]"
//       >
//         <FormFieldSet title="Template Name" value={style} />
//         <div className="grid grid-cols-2 gap-3 my-3">
//           <FormFieldSet title="First Name" placeholder="First Name" />
//           <FormFieldSet title="Last Name" placeholder="Last Name" />
//           <FormFieldSet title="Designation" placeholder="Designation" />
//           <FormFieldSet title="Email" placeholder="Email" />
//           <FormFieldSet title="Phone" placeholder="Phone" />
//           <FormFieldSet title="Phone Extension" placeholder="Phone Extension" />
//           <FormFieldSet
//             title="Mobile"
//             type="phone"
//             placeholder="Phone Extension"
//           />
//           <FormFieldSet title="Website" placeholder="Website" />
//           <FormFieldSet title="Address" placeholder="Address" />
//           <FormFieldSet title="FaceBook URL" placeholder="FaceBook URL" />
//           <FormFieldSet title="Twitter URL" placeholder="Twitter URL" />
//           <FormFieldSet title="Linkedin URL" placeholder="Linkedin Url" />
//           <FormFieldSet title="Google URL" placeholder="Google URL" />
//         </div>
//         <div className="flex items-center justify-end gap-2">
//           <Button
//             variant="outlined"
//             title={"Cancel"}
//             size="sm"
//             onClick={() => setEditModal(false)}
//           />
//           <Button title={"Save"} size="sm" />
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default SignatureCard;

// import React, { useState } from "react";
// import Avatar from "../Common/Avatar";
// import pic from "../../assets/images/profile-dummy.png";
// import Button from "../Buttons/Button";
// import Drawer from "../Modal/Drawer";
// import FormFieldSet from "../FormFields/FormFieldSet";
// import { useDispatch } from "react-redux";
// import { updateSignatureStart } from "../../redux/slices/signatures/signaturesSlice";

// const SignatureCard = ({
//   style = "Style-1",
//   name = "Anna Jack",
//   title = "Junior Frontend Developer",
//   phone = "9604637578",
//   mobile = "1111111111",
//   web = "yue@yu.in",
//   email = "annajack54@gmail.com",
//   address = "76, Church street, Dallas, USA",
//   image = "",
//   socialIcons = [
//     { icon: "f", className: "bg-info-200 text-info-500" },
//     { icon: "in", className: "text-white bg-info-500" },
//     { icon: "m", className: "bg-info-200 text-info-500" },
//     { icon: "x", className: "bg-info-200 text-info-500" },
//   ],
//   uiid,
// }) => {
//   const [editModal, setEditModal] = useState(false);
//   const dispatch = useDispatch();

//   // Split full name into first/last
//   const [formData, setFormData] = useState({
//     templateName: style,
//     firstName: name.split(" ")[0] || "",
//     lastName: name.split(" ")[1] || "",
//     designation: title,
//     email,
//     phone,
//     phoneExtension: "",
//     mobile,
//     website: web,
//     address,
//   });

//   const handleChange = (key, value) => {
//     setFormData((prev) => ({ ...prev, [key]: value }));
//   };

//   // const handleSave = () => {
//   //   console.log("Signature Data to send backend:", formData);
//   //   setEditModal(false);
//   // };
//   // const handleSave = () => {
//   //   // Split mobile into code + number
//   //   const [code, ...numberParts] = formData.mobile.trim().split(" ");
//   //   const number = numberParts.join("");

//   //   const payload = [
//   //     {
//   //       type: "SET",
//   //       value: {
//   //         templateName: formData.templateName,
//   //         firstName: formData.firstName,
//   //         lastName: formData.lastName,
//   //         designation: formData.designation,
//   //         email: formData.email,
//   //         mobileNumber: {
//   //           code: code || "+91",
//   //           number: number || "",
//   //         },
//   //         address: formData.address,
//   //       },
//   //     },
//   //   ];

//   //   // Dispatch update API
//   //   dispatch(updateSignatureStart({ uiid: uiid, payload }));

//   //   // Close modal
//   //   setEditModal(false);
//   // };
//   const handleSave = () => {
//     let code = "+91";
//     let number = formData.mobile;

//     if (formData.mobile.includes(" ")) {
//       const parts = formData.mobile.trim().split(" ");
//       code = parts[0] || code;
//       number = parts.slice(1).join("") || "";
//     }

//     const payload = [
//       {
//         type: "SET",
//         value: {
//           templateName: formData.templateName,
//           firstName: formData.firstName,
//           lastName: formData.lastName,
//           designation: formData.designation,
//           email: formData.email,
//           mobileNumber: { code, number },
//           address: formData.address || "—",
//         },
//       },
//     ];

//     dispatch(updateSignatureStart({ uiid, payload }));
//     setEditModal(false);
//   };

//   return (
//     <div className="relative border border-neutrals-500 rounded">
//       {/* Label */}
//       <div className="bg-primary-200 text-neutrals-700 px-3 py-1 text-sm font-medium w-fit rounded-br-xl absolute -left-1 -top-1">
//         {style}
//       </div>

//       {/* Card Body */}
//       <div className="flex gap-4 p-3 pt-8 flex-1">
//         {/* Profile Section */}
//         <div className="flex flex-col flex-shrink-0">
//           {image ? (
//             <img
//               src={image}
//               className="w-20 h-20 rounded object-cover"
//               alt="Profile"
//             />
//           ) : (
//             <Avatar className="w-20 h-20" src={pic} />
//           )}

//           {/* Social Icons */}
//           {socialIcons.length > 0 && (
//             <div className="flex gap-2 my-4 flex-wrap">
//               {socialIcons.map((social, index) => (
//                 <div
//                   key={index}
//                   className={`text-center px-1 text-sm rounded ${
//                     social.className || "bg-info-200 text-info-500"
//                   }`}
//                 >
//                   {social.icon || social.text}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Info Section */}
//         <div className="flex flex-1 flex-col ">
//           <div className="flex justify-between items-center">
//             <div className="flex-1 ">
//               <p className="font-semibold text-2xl truncate">
//                 {formData.firstName} {formData.lastName}
//               </p>
//               <p className="text-gray-600 text-xs">{formData.designation}</p>
//             </div>
//             <Button
//               type="icon"
//               variant="text"
//               color="black"
//               icon={"edit"}
//               size="xl"
//               onClick={() => setEditModal(true)}
//             />
//           </div>

//           {/* Details */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-3 mt-3 text-sm flex-1">
//             <p className="truncate">
//               <span className="font-medium">Phone:</span> {formData.phone}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Mobile:</span> {formData.mobile}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Web:</span> {formData.website}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Email:</span> {formData.email}
//             </p>
//             <div className="col-span-1 sm:col-span-2">
//               <p>
//                 <span className="font-medium">Address:</span> {formData.address}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Drawer (Edit Form) */}
//       <Drawer
//         title={"Edit Signature"}
//         isOpen={editModal}
//         onClose={() => setEditModal(false)}
//         width="w-[50%]"
//       >
//         <FormFieldSet
//           title="Template Name"
//           value={formData.templateName}
//           onChange={(val) => handleChange("templateName", val)}
//           placeholder="Template Name"
//         />
//         <div className="grid grid-cols-2 gap-3 my-3">
//           <FormFieldSet
//             title="First Name"
//             value={formData.firstName}
//             onChange={(val) => handleChange("firstName", val)}
//             placeholder="First Name"
//           />
//           <FormFieldSet
//             title="Last Name"
//             value={formData.lastName}
//             onChange={(val) => handleChange("lastName", val)}
//             placeholder="Last Name"
//           />
//           <FormFieldSet
//             title="Designation"
//             value={formData.designation}
//             onChange={(val) => handleChange("designation", val)}
//             placeholder="Designation"
//           />
//           <FormFieldSet
//             title="Email"
//             value={formData.email}
//             onChange={(val) => handleChange("email", val)}
//             placeholder="Email"
//           />
//           {/* <FormFieldSet
//             title="Phone"
//             value={formData.phone}
//             onChange={(val) => handleChange("phone", val)}
//             placeholder="Phone"
//           />
//           <FormFieldSet
//             title="Phone Extension"
//             value={formData.phoneExtension}
//             onChange={(val) => handleChange("phoneExtension", val)}
//             placeholder="Phone Extension"
//           /> */}
//           <FormFieldSet
//             title="Mobile"
//             type="phone"
//             value={formData.mobile}
//             onChange={(val) => handleChange("mobile", val)}
//             placeholder="Mobile"
//           />
//           {/* <FormFieldSet
//             title="Website"
//             value={formData.website}
//             onChange={(val) => handleChange("website", val)}
//             placeholder="Website"
//           /> */}
//           <FormFieldSet
//             title="Address"
//             value={formData.address}
//             onChange={(val) => handleChange("address", val)}
//             placeholder="Address"
//           />
//           {/* <FormFieldSet
//             title="Facebook URL"
//             value={formData.facebook}
//             onChange={(val) => handleChange("facebook", val)}
//             placeholder="Facebook URL"
//           />
//           <FormFieldSet
//             title="Twitter URL"
//             value={formData.twitter}
//             onChange={(val) => handleChange("twitter", val)}
//             placeholder="Twitter URL"
//           />
//           <FormFieldSet
//             title="LinkedIn URL"
//             value={formData.linkedin}
//             onChange={(val) => handleChange("linkedin", val)}
//             placeholder="LinkedIn URL"
//           />
//           <FormFieldSet
//             title="Google URL"
//             value={formData.google}
//             onChange={(val) => handleChange("google", val)}
//             placeholder="Google URL"
//           /> */}
//         </div>
//         <div className="flex items-center justify-end gap-2">
//           <Button
//             variant="outlined"
//             title={"Cancel"}
//             size="sm"
//             onClick={() => setEditModal(false)}
//           />
//           <Button title={"Save"} size="sm" onClick={handleSave} />
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default SignatureCard;

// import React, { useState, useEffect } from "react";
// import Avatar from "../Common/Avatar";
// import pic from "../../assets/images/profile-dummy.png";
// import Button from "../Buttons/Button";
// import Drawer from "../Modal/Drawer";
// import FormFieldSet from "../FormFields/FormFieldSet";
// import { useDispatch } from "react-redux";
// import { updateSignatureStart } from "../../redux/slices/signatures/signaturesSlice";

// const SignatureCard = ({
//   style = "Style-1",
//   name = "Anna Jack",
//   designation = "Junior Frontend Developer",
//   phone = "9604637578",
//   mobile = "1111111111",
//   website = "yue@yu.in",
//   email = "annajack54@gmail.com",
//   address = "76, Church street, Dallas, USA",
//   image = "",
//   socialIcons = [
//     { icon: "f", className: "bg-info-200 text-info-500" },
//     { icon: "in", className: "text-white bg-info-500" },
//     { icon: "m", className: "bg-info-200 text-info-500" },
//     { icon: "x", className: "bg-info-200 text-info-500" },
//   ],
//   uiid,
// }) => {
//   const [editModal, setEditModal] = useState(false);
//   const dispatch = useDispatch();

//   // Initialize formData
//   const [formData, setFormData] = useState({
//     templateName: style,
//     firstName: name.split(" ")[0] || "",
//     lastName: name.split(" ")[1] || "",
//     designation: designation || "",
//     email,
//     phone,
//     mobile,
//     website,
//     address:
//       typeof address === "string"
//         ? address
//         : [address.city, address.state, address.country]
//             .filter(Boolean)
//             .join(", "),
//     phoneExtension: "",
//   });

//   // Keep formData in sync if props change
//   useEffect(() => {
//     setFormData({
//       templateName: style,
//       firstName: name.split(" ")[0] || "",
//       lastName: name.split(" ")[1] || "",
//       designation: designation || "",
//       email,
//       phone,
//       mobile,
//       website,
//       address:
//         typeof address === "string"
//           ? address
//           : [address.city, address.state, address.country]
//               .filter(Boolean)
//               .join(", "),
//       phoneExtension: formData.phoneExtension,
//     });
//   }, [style, name, designation, email, phone, mobile, website, address]);

//   const handleChange = (key, value) => {
//     setFormData((prev) => ({ ...prev, [key]: value }));
//   };

//   const handleSave = () => {
//     let code = "+91";
//     let number = formData.mobile;

//     if (formData.mobile.includes(" ")) {
//       const parts = formData.mobile.trim().split(" ");
//       code = parts[0] || code;
//       number = parts.slice(1).join("") || "";
//     }

//     // const payload = [
//     //   {
//     //     type: "SET",
//     //     value: {
//     //       templateName: formData.templateName,
//     //       firstName: formData.firstName,
//     //       lastName: formData.lastName,
//     //       designation: formData.designation,
//     //       email: formData.email,
//     //       mobileNumber: { code, number },
//     //       address:
//     //         typeof formData.address === "string"
//     //           ? { city: formData.address, state: "", country: "" }
//     //           : {
//     //               city: formData.address.city || "",
//     //               state: formData.address.state || "",
//     //               country: formData.address.country || "",
//     //             },
//     //     },
//     //   },
//     // ];
//     const payload = {
//       payload: [
//         {
//           type: "SET",
//           value: {
//             templateName: formData.templateName,
//             firstName: formData.firstName,
//             lastName: formData.lastName,
//             designation: formData.designation,
//             email: formData.email,
//             mobileNumber: { code, number },
//             address:
//               typeof formData.address === "string"
//                 ? { city: formData.address, state: "", country: "" }
//                 : {
//                     city: formData.address.city || "",
//                     state: formData.address.state || "",
//                     country: formData.address.country || "",
//                   },
//           },
//         },
//       ],
//     };

//     dispatch(updateSignatureStart({ uiid, payload }));
//     setEditModal(false);
//   };

//   // const handleSave = () => {
//   //   let code = "";
//   //   let number = formData.mobile;

//   //   // If mobile input contains a space (e.g., "+44 1234567890")
//   //   if (formData.mobile.includes(" ")) {
//   //     const parts = formData.mobile.trim().split(" ");
//   //     code = parts[0] || "";
//   //     number = parts.slice(1).join("") || "";
//   //   } else {
//   //     code = formData.phoneExtension || ""; // optional separate field
//   //     number = formData.mobile;
//   //   }

//   //   const payload = {
//   //     coll: "Signature",
//   //     payload: {
//   //       templateName: formData.templateName,
//   //       firstName: formData.firstName || "",
//   //       lastName: formData.lastName || "",
//   //       designation: formData.designation || "",
//   //       email: formData.email || "",
//   //       mobileNumber: {
//   //         code: code || "", // use code from input, empty string if missing
//   //         number: number || "",
//   //       },
//   //       addedBy: user?.data?.uiid || "", // optional
//   //       address:
//   //         typeof formData.address === "string"
//   //           ? { city: formData.address, state: "", country: "" }
//   //           : {
//   //               city: formData.address.city || "",
//   //               state: formData.address.state || "",
//   //               country: formData.address.country || "",
//   //             },
//   //     },
//   //   };

//   //   dispatch(updateSignatureStart({ uiid, payload }));
//   //   setEditModal(false);
//   // };

//   return (
//     <div className="relative border border-neutrals-500 rounded">
//       {/* Label */}
//       <div className="bg-primary-200 text-neutrals-700 px-3 py-1 text-sm font-medium w-fit rounded-br-xl absolute -left-1 -top-1">
//         {style}
//       </div>

//       {/* Card Body */}
//       <div className="flex gap-4 p-3 pt-8 flex-1">
//         {/* Profile */}
//         <div className="flex flex-col flex-shrink-0">
//           {image ? (
//             <img
//               src={image}
//               className="w-20 h-20 rounded object-cover"
//               alt="Profile"
//             />
//           ) : (
//             <Avatar className="w-20 h-20" src={pic} />
//           )}

//           {/* Social Icons */}
//           {socialIcons.length > 0 && (
//             <div className="flex gap-2 my-4 flex-wrap">
//               {socialIcons.map((social, index) => (
//                 <div
//                   key={index}
//                   className={`text-center px-1 text-sm rounded ${
//                     social.className || "bg-info-200 text-info-500"
//                   }`}
//                 >
//                   {social.icon || social.text}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Info */}
//         <div className="flex flex-1 flex-col">
//           <div className="flex justify-between items-center">
//             <div className="flex-1">
//               <p className="font-semibold text-2xl truncate">
//                 {formData.firstName} {formData.lastName}
//               </p>
//               <p className="text-gray-600 text-xs">{formData.designation}</p>
//             </div>
//             <Button
//               type="icon"
//               variant="text"
//               color="black"
//               icon="edit"
//               size="xl"
//               onClick={() => setEditModal(true)}
//             />
//           </div>

//           {/* Details */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-3 mt-3 text-sm flex-1">
//             <p className="truncate">
//               <span className="font-medium">Phone:</span> {formData.phone}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Mobile:</span> {formData.mobile}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Web:</span> {formData.website}
//             </p>
//             <p className="truncate">
//               <span className="font-medium">Email:</span> {formData.email}
//             </p>
//             <div className="col-span-1 sm:col-span-2">
//               <p>
//                 <span className="font-medium">Address:</span> {formData.address}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Drawer (Edit Form) */}
//       <Drawer
//         title="Edit Signature"
//         isOpen={editModal}
//         onClose={() => setEditModal(false)}
//         width="w-[50%]"
//       >
//         <FormFieldSet
//           title="Template Name"
//           value={formData.templateName}
//           onChange={(val) => handleChange("templateName", val)}
//           placeholder="Template Name"
//         />
//         <div className="grid grid-cols-2 gap-3 my-3">
//           <FormFieldSet
//             title="First Name"
//             value={formData.firstName}
//             onChange={(val) => handleChange("firstName", val)}
//             placeholder="First Name"
//           />
//           <FormFieldSet
//             title="Last Name"
//             value={formData.lastName}
//             onChange={(val) => handleChange("lastName", val)}
//             placeholder="Last Name"
//           />
//           <FormFieldSet
//             title="Designation"
//             value={formData.designation}
//             onChange={(val) => handleChange("designation", val)}
//             placeholder="Designation"
//           />
//           <FormFieldSet
//             title="Email"
//             value={formData.email}
//             onChange={(val) => handleChange("email", val)}
//             placeholder="Email"
//           />
//           {/* <FormFieldSet
//             title="Phone"
//             value={formData.phone}
//             onChange={(val) => handleChange("phone", val)}
//             placeholder="Phone"
//           /> */}
//           <FormFieldSet
//             title="Mobile"
//             value={formData.mobile}
//             type="phone"
//             onChange={(val) => handleChange("mobile", val)}
//             placeholder="Mobile"
//           />

//           {/* <FormFieldSet
//             title="Website"
//             value={formData.website}
//             onChange={(val) => handleChange("website", val)}
//             placeholder="Website"
//           /> */}
//           <FormFieldSet
//             title="Address"
//             value={formData.address}
//             onChange={(val) => handleChange("address", val)}
//             placeholder="Address"
//           />
//         </div>
//         <div className="flex items-center justify-end gap-2">
//           <Button
//             variant="outlined"
//             title="Cancel"
//             size="sm"
//             onClick={() => setEditModal(false)}
//           />
//           <Button title="Save" size="sm" onClick={handleSave} />
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default SignatureCard;

import React, { useState, useEffect } from "react";
import Avatar from "../Common/Avatar";
import pic from "../../assets/images/profile-dummy.png";
import Button from "../Buttons/Button";
import Drawer from "../Modal/Drawer";
import FormFieldSet from "../FormFields/FormFieldSet";
import { useDispatch } from "react-redux";
import { updateSignatureStart } from "../../redux/slices/signatures/signaturesSlice";
import { UserDesignations } from "../../assets/data/enumData";

export const getUserDesignationLabel = (value) => {
  return UserDesignations.find(d => d.value === Number(value))?.label || "";
};

const SignatureCard = ({
  style = "Style-1",
  name = "Anna Jack",
  designation = "Junior Frontend Developer",
  phone = "9604637578",
  mobile = "+91 1111111111",
  website = "yue@yu.in",
  email = "annajack54@gmail.com",
  address = "76, Church street, Dallas, USA",
  image = "",
  socialIcons = [
    { icon: "f", className: "bg-info-200 text-info-500" },
    { icon: "in", className: "text-white bg-info-500" },
    { icon: "m", className: "bg-info-200 text-info-500" },
    { icon: "x", className: "bg-info-200 text-info-500" },
  ],
  uiid,
}) => {
  const [editModal, setEditModal] = useState(false);
  const dispatch = useDispatch();

  // Split mobile into code and number
  const splitMobile = (mobileStr) => {
    if (!mobileStr) return { code: "+91", number: "" };
    const parts = mobileStr.trim().split(" ");
    return {
      code: parts[0] || "+91",
      number: parts.slice(1).join("") || "",
    };
  };

  const { code: mobileCode, number: mobileNumber } = splitMobile(mobile);

  // Initialize formData
  const [formData, setFormData] = useState({
    templateName: style,
    firstName: name.split(" ")[0] || "",
    lastName: name.split(" ")[1] || "",
    designation: designation || "",
    email,
    phone,
    mobileCode,
    mobileNumber,
    website,
    address:
      typeof address === "string"
        ? address
        : [address.city, address.state, address.country]
            .filter(Boolean)
            .join(", "),
  });

  // Sync props
  useEffect(() => {
    const { code, number } = splitMobile(mobile);
    setFormData({
      templateName: style,
      firstName: name.split(" ")[0] || "",
      lastName: name.split(" ")[1] || "",
      designation: designation || "",
      email,
      phone,
      mobileCode: code,
      mobileNumber: number,
      website,
      address:
        typeof address === "string"
          ? address
          : [address.city, address.state, address.country]
              .filter(Boolean)
              .join(", "),
    });
  }, [style, name, designation, email, phone, mobile, website, address]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    const payload = {
      payload: [
        {
          type: "SET",
          value: {
            templateName: formData.templateName,
            firstName: formData.firstName,
            lastName: formData.lastName,
            designation: formData.designation,
            email: {
              email: formData.email
            },
            mobileNumber: {
              code: formData.mobileCode || "+91",
              number: formData.mobileNumber || "",
            },
            address:
              typeof formData.address === "string"
                ? { city: formData.address, state: "", country: "" }
                : {
                    city: formData.address.city || "",
                    state: formData.address.state || "",
                    country: formData.address.country || "",
                  },
          },
        },
      ],
    };
    dispatch(updateSignatureStart({ uiid, payload }));
    setEditModal(false);
  };

  return (
    <div className="relative border border-neutrals-500 rounded">
      {/* Label */}
      <div className="bg-primary-200 text-neutrals-700 px-3 py-1 text-sm font-medium w-fit rounded-br-xl absolute -left-1 -top-1">
        {style}
      </div>

      {/* Card Body */}
      <div className="flex gap-4 p-3 pt-8 flex-1">
        {/* Profile */}
        <div className="flex flex-col flex-shrink-0">
          {image ? (
            <img
              src={image}
              className="w-20 h-20 rounded object-cover"
              alt="Profile"
            />
          ) : (
            <Avatar className="w-20 h-20" src={pic} />
          )}

          {/* Social Icons */}
          {socialIcons.length > 0 && (
            <div className="flex gap-2 my-4 flex-wrap">
              {socialIcons.map((social, index) => (
                <div
                  key={index}
                  className={`text-center px-1 text-sm rounded ${
                    social.className || "bg-info-200 text-info-500"
                  }`}
                >
                  {social.icon || social.text}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Info */}
        <div className="flex flex-1 flex-col">
          <div className="flex justify-between items-center">
            <div className="flex-1">
              <p className="font-semibold text-2xl truncate">
                {formData.firstName} {formData.lastName}
              </p>
              <p className="text-gray-600 text-xs">{getUserDesignationLabel(formData.designation)}</p>
            </div>
            <Button
              type="icon"
              variant="text"
              color="black"
              icon="edit"
              size="xl"
              onClick={() => setEditModal(true)}
            />
          </div>

          {/* Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 2xl:grid-cols-2 gap-y-3 mt-3 text-sm">
    <p>
    <span className="font-medium">Phone:</span> {formData.phone}
    </p>
  <p>
    <span className="font-medium">Mobile:</span>{" "}
    {`${formData.mobileCode} ${formData.mobileNumber}`}
  </p>
  <p>
    <span className="font-medium">Web:</span> {formData.website}
  </p>
  <p>
    <span className="font-medium">Email:</span> {formData.email}
  </p>
  <p>
    <span className="font-medium">Address:</span> {formData.address}
  </p>
</div>
        </div>
      </div>

      {/* Drawer (Edit Form) */}
      <Drawer
        title="Edit Signature"
        isOpen={editModal}
        onClose={() => setEditModal(false)}
        width="w-[50%]"
      >
        <FormFieldSet
          title="Template Name"
          value={formData.templateName}
          onChange={(val) => handleChange("templateName", val)}
          placeholder="Template Name"
        />
        <div className="grid grid-cols-2 gap-3 my-3">
          <FormFieldSet
            title="First Name"
            value={formData.firstName}
            onChange={(val) => handleChange("firstName", val)}
            placeholder="First Name"
          />
          <FormFieldSet
            title="Last Name"
            value={formData.lastName}
            onChange={(val) => handleChange("lastName", val)}
            placeholder="Last Name"
          />
          <FormFieldSet
            type="select"
            options={UserDesignations}
            title="Designation"
            value={formData.designation}
            onChange={(val) => handleChange("designation", String(val))}
            placeholder="Designation"
          />
          <FormFieldSet
            title="Email"
            value={formData.email}
            onChange={(val) => handleChange("email", val)}
            placeholder="Email"
          />
          <FormFieldSet
            title="Mobile"
            type="phone"
            code={formData.mobileCode}
            value={formData.mobileNumber}
            onChange={(fullValue, details) => {
              handleChange("mobileCode", details.countryCode);
              handleChange("mobileNumber", details.number);
            }}
            placeholder="Mobile"
          />
          <FormFieldSet
            title="Address"
            value={formData.address}
            onChange={(val) => handleChange("address", val)}
            placeholder="Address"
          />
        </div>
        <div className="flex items-center justify-end gap-2">
          <Button
            variant="outlined"
            title="Cancel"
            size="sm"
            onClick={() => setEditModal(false)}
          />
          <Button title="Save" size="sm" onClick={handleSave} />
        </div>
      </Drawer>
    </div>
  );
};

export default SignatureCard;
